<ng-container [formGroup]="form()" class=" scrollable-container" style="padding: 2rem">
  <div class="row">
    <div class="col-md-4 mb-1 text-center">
      <label for="type" class="form-label text-muted">{{ 'DELIVERY.DELIVERY_NAME' | translate }} </label>
      <input type="text" class="form-control input-field" id="type" formControlName="deliveryName" [disabled]="true">
    </div>

    <div class="col-md-4 mb-1 text-center">
      <label for="type" class="form-label text-muted">{{ 'DELIVERY.CUSTOMER' | translate }} </label>
      <input type="text" class="form-control input-field" id="type" formControlName="customer">
    </div>
    <div class="col-md-4 mb-1 text-center">
      <label for="type" class="form-label text-muted">{{ 'DELIVERY.KILO_TOTAL' | translate }}</label>
      <input type="number" class="form-control input-field" id="type" formControlName="kiloTotal">
    </div>
  </div>

  <div class="row">

    <div class="col-md-6 mb-1 text-center">
      <label for="name" class="form-label text-muted">{{ 'DELIVERY.BOUTEFEU' | translate }} </label>
      <ng-select [items]="managers()" [multiple]="false" [closeOnSelect]="false" bindLabel="nom"
        placeholder="Boutefeu" name="boutefeu" id="boutefeu" [clearSearchOnAdd]="true" bindValue="nom"
        formControlName="boutefeu" dropdownPosition="top" [addTag]="true" class="select-field-dopdown-checkbox">
      </ng-select>
    </div>

    <div class="col-md-6 mb-1 text-center">
      <label for="name" class="form-label text-muted">{{ 'DELIVERY.OPERATORS' | translate }} </label>
      <ng-select [items]="operators()" [multiple]="true" [closeOnSelect]="false" bindLabel="nom"
        placeholder="Operators" name="operators" id="operators" [clearSearchOnAdd]="true" bindValue="operatorId"
        formControlName="operators" dropdownPosition="top" [addTag]="true" class="select-field-dopdown-checkbox">
      </ng-select>
    </div>
  </div>

  <div class="row">
    <div class="col-md-4 mb-1 text-center">
      <label for="type" class="form-label text-muted">{{ 'DELIVERY.TEAM' | translate }} </label>
      <ng-select [items]="deliveryParams()?.teams" [multiple]="false" [closeOnSelect]="false" bindLabel="nom"
        placeholder="Team" name="team" id="team" [clearSearchOnAdd]="true" bindValue="equipeId"
        formControlName="team" dropdownPosition="top" [addTag]="true"
        class="custom select-field-dopdown-checkbox">
      </ng-select>
    </div>
    <div class="col-md-4 mb-1 text-center">
      <label for="name" class="form-label text-muted">{{ 'DELIVERY.TRUCK' | translate }} </label>
      <ng-select [items]="deliveryParams()?.equipements" [multiple]="true" [closeOnSelect]="false" bindLabel="name"
        placeholder="{{ 'DELIVERY.SELECT_TRUCK' | translate }}" name="truck" id="truck" [clearSearchOnAdd]="true" bindValue="equipementId"
        formControlName="truck" dropdownPosition="top" class="custom select-field-dopdown-checkbox"
        [clearable]="true">
      </ng-select>
    </div>

    <div class="col-md-4 mb-1 text-center">
      <label for="name" class="form-label text-muted">{{ 'DELIVERY.DRILL' | translate }}</label>
      <ng-select [items]="deliveryParams()?.equipements" [multiple]="true" [closeOnSelect]="false" bindLabel="name"
        placeholder="{{ 'DELIVERY.SELECT_DRILL' | translate }}" name="drill" id="drill" [clearSearchOnAdd]="true" bindValue="equipementId"
        formControlName="drill" dropdownPosition="top" class="custom select-field-dopdown-checkbox"
        [clearable]="true">
      </ng-select>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6 mb-1 text-center">
      <label for="type" class="form-label text-muted">{{ 'DELIVERY.FORMULATION' | translate }} </label>
      <input type="text" class="form-control input-field" id="type" formControlName="formulation">
    </div>
    <div class="col-md-6 mb-1 text-center">
      <label for="type" class="form-label text-muted">{{ 'DELIVERY.HOLE_DIAMETER' | translate }} (mm)</label>
      <input type="number" class="form-control input-field" id="type" [value]="getHoleDiameterInMm()" (input)="setHoleDiameterFromMm($event)">
    </div>
  </div>

  <div class="row">
    <div class="col-md-6 mb-1 text-center">
      <label for="type" class="form-label text-muted">{{ 'DELIVERY.DEPARTURE_DATE' | translate }} </label>
      <input type="date" class="form-control input-field" id="type" formControlName="departureDate">
    </div>

    <div class="col-md-6 mb-1 text-center">
      <label for="name" class="form-label text-muted">{{ 'DELIVERY.DEPARTURE_TIME' | translate }} </label>
      <input type="time" class="form-control input-field" id="name" formControlName="departureTime">
    </div>
  </div>

  <div class="row">
    <div class="col-md-6 mb-1 text-center">
      <label for="type" class="form-label text-muted">{{ 'DELIVERY.START_DATE' | translate }} </label>
      <input type="date" class="form-control input-field" id="type" formControlName="startDate">
    </div>

    <div class="col-md-6 mb-1 text-center">
      <label for="name" class="form-label text-muted">{{ 'DELIVERY.START_TIME' | translate }}</label>
      <input type="time" class="form-control input-field" id="name" formControlName="startTime">
    </div>
  </div>

  <div class="row">
    <div class="col-md-6 mb-1 text-center">
      <label for="type" class="form-label text-muted">{{ 'DELIVERY.END_DATE' | translate }}</label>
      <input type="date" class="form-control input-field" id="type" formControlName="endDate">
    </div>

    <div class="col-md-6 mb-1 text-center">
      <label for="name" class="form-label text-muted">{{ 'DELIVERY.END_TIME' | translate }} </label>
      <input type="time" class="form-control input-field" id="name" formControlName="endTime">
    </div>
  </div>

  @if (form()?.errors?.dateInvalid) {
    <div class="mt-2">
      <div class="alert alert-danger">
        {{ 'DELIVERY.INVALID_DATE' | translate }}
      </div>
    </div>
  }


  <div class="d-flex justify-content-center pt-1 text-center" style="gap: 20px; margin-top: 2rem">
    <button type="button" class="btn btn-sm btn-secondary w-30"
    (click)="onClose()">{{ 'GLOBAL.ANNULER' | translate }}</button>
    <button type="submit" class="btn btn-sm btn-primary w-30"
    (click)="onSubmit()">{{ 'GLOBAL.CONFIRMER' | translate }}</button>
  </div>

  <div class="row mt-2">
    <div class="col-md-3">
      {{ 'DELIVERY.REAFFECT_DELIVERY' | translate }}
    </div>
    <div class="col-md-9">
      <hr>
      </div>
    </div>
    <div class="row border border-1  rounded p-1 m-2">
      <div class="col-md-10 mb-1 text-center">
        <label for="blast" class="form-label text-muted">{{ 'DELIVERY.DESTINATION_BLAST_ID' | translate }}</label>
        <input type="number" class="form-control input-field" id="blast" formControlName="destBlastId"
          (ngModelChange)="onDestBlastIdChange(form().get('destBlastId')?.value)" [(ngModel)]="destBlastId">
        </div>

        <div class="col-md-2" style="margin-top: 2rem;">
          <button type="submit" class="btn btn-sm btn-primary  w-30" (click)="onMoveDelivery(destBlastId())">
            {{ 'DELIVERY.MOVE' | translate }}
          </button>
        </div>
        <div class="ms-2">
          @if (wrongSiteAlerte()) {
            <span class="text-danger">{{wrongSiteAlerte()}}</span>
          }
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-md-3">
          {{ 'DELIVERY.MERGE_DELIVERY' | translate }}
        </div>
        <div class="col-md-9">
          <hr>
          </div>
        </div>

        <div class="row border border-1 rounded p-1 m-2">
          <div class="col-md-10 mb-1 text-center">
            <label for="mergeDelivery" class="form-label text-muted">{{ 'DELIVERY.SELECT_DELIVERY_TO_MERGE' | translate }}</label>
            <ng-select
              [items]="availableDeliveries()"
              bindLabel="name"
              placeholder="{{ 'DELIVERY.SELECT_DELIVERY_PLACEHOLDER' | translate }}"
              [(ngModel)]="selectedMergeDelivery"
              (change)="onMergeDeliveryChange($event)"
              [clearable]="true"
              class="custom select-field-dopdown-checkbox">
            </ng-select>
          </div>

          <div class="col-md-2" style="margin-top: 2rem;">
            <button type="button"
              class="btn btn-sm btn-primary w-30"
              [disabled]="!selectedMergeDelivery()"
              (click)="onMergeDelivery()">
              {{ 'DELIVERY.MERGE' | translate }}
            </button>
          </div>
        </div>

        @if (showMergeConfirmation()) {
          <div class="modal-overlay">
            <div class="modal-content">
              <h4 class="mb-3">{{ 'DELIVERY.CONFIRM_MERGE' | translate }}</h4>
              <div class="alert alert-info-custom">
                <p>{{ 'DELIVERY.MERGE_WARNING_MESSAGE' | translate }}</p>
                <ul>
                  <li>{{ 'DELIVERY.CURRENT_DELIVERY_DELETED' | translate }}</li>
                  <li>{{ 'DELIVERY.HOLES_MOVED_TO' | translate }} "{{selectedMergeDelivery()?.name}}"</li>
                </ul>
                <p><strong>{{ 'DELIVERY.MERGE_CONFIRMATION_QUESTION' | translate }}</strong></p>
              </div>
              <div class="d-flex justify-content-center pt-1 text-center" style="gap: 20px;">
                <button type="button" class="btn btn-sm btn-outline-secondary w-30" (click)="cancelMergeDelivery()">
                  {{ 'GLOBAL.ANNULER' | translate }}
                </button>
                <button type="button" class="btn btn-sm btn-primary w-30" (click)="confirmMergeDelivery()">
                  {{ 'DELIVERY.MERGE' | translate }}
                </button>
              </div>
            </div>
          </div>
        }
      </ng-container>